export default [
  {
    key: "huaercollegiate", // sso来源
    tenantId: "5ee1da1e1b370000df000794", // 租户id
    logo: "https://njstatic.dipont.com/huayao-logo.png", // logo
    tenantName: "昆山狄邦华曜学校", // 租户名称
    tenantEnName: "昆山狄邦华曜学校", // 租户英文名称
    loginType: ["LDAP", "INTOA", "OFFICE"], // 登录方式 LDAP-域控登录，INTOA-账号密码登录, OFFICE-office365登录
    // 不同环境INTOA登录方式的后缀
    config: {
      production: ["@dipont-hc.com", "@dipont.com"],
      default: ["@njrd.com", "@dipont-hc.com", "@dipont.com"],
    },
    // huaer匹配的host, development和qa环境需要配置本地hosts，具体见README.md
    host: {
      production: "huaer.dipont.com",
      qa: "kunshan.dipont.com:9296",
      development: "kunshan.intunion.com:8080",
      uat: "njcenter.dipont.com:3014",
    },
  },
  {
    key: "chengducollegiate",
    tenantId: "606ed3257f540000e300642a",
    logo: "https://njstatic.dipont.com/kcscd-logo.png",
    tenantName: "成都狄邦肯思学校",
    tenantEnName: "DIPONT KCS CHENGDU",
    loginType: ["INTOA"],
    config: {
      production: [],
      default: [],
    },
    host: {
      production: "kcschengdu.dipont.com",
      qa: "chengdu.dipont.com:9296",
      development: "chengdu.intunion.com:8080",
      uat: "122.96.107.58:3016",
    },
  },
  {
    key: "hangzhoucollegiate",
    tenantId: "62b2bc54d91400009d007c92",
    logo: "https://njstatic.dipont.com/hz-logo.png",
    tenantName: "人大附中杭州学校",
    tenantEnName: "DIPONT KCS CHENGDU",
    loginType: ["INTOA", "OFFICE"],
    config: {
      production: [],
      default: [],
    },
    host: {
      production: "hangzhou.dipont.com",
      qa: "hangzhou.intunion.com:9296",
      development: "hangzhou.intunion.com:8080",
      uat: "njcenter.dipont.com:3018",
    },
  },
  {
    key: "testcollegiate",
    tenantId: "609cc03a66660000f6005fd8",
    logo: "https://njstatic.dipont.com/ts-logo.jpg",
    tenantName: "测试学校",
    tenantEnName: "测试学校",
    loginType: ["LDAP", "INTOA"],
    config: {
      production: ["@dipont-hc.com", "@dipont.com"],
      default: ["@njrd.com", "@dipont-hc.com", "@dipont.com"],
    },
    host: {
      production: "demo.intschool.cn",
      qa: "test.dipont.com:9296",
      development: "test.intunion.com:8080",
      uat: "122.96.107.58:3017",
    },
  },
];
